import IndexHeader from "app/shared-components/IndexHeader";
import React, { useEffect, useState } from "react";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";
import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
} from "@mui/material";
import { ProgramSalaryDetail } from "src/app/interfaces/my.youth";
import { myYouthService } from "src/app/services/api/my-youth.service";
import YouthSelectGroup from "app/shared-components/YouthSelectGroup";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#202441",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const SalaryDetails: React.FC = () => {
  const [salaryDetails, setSalaryDetails] = useState<ProgramSalaryDetail[]>([]);

  useEffect(() => {
    fetchSalaryDetails();
  }, []);

  const fetchSalaryDetails = (): void => {
    myYouthService
      .getSalaryDetails()
      .then((res) => setSalaryDetails(res.data.salaryDetails))
      .catch((err) =>
        console.error("Failed to load youth requests", err.message)
      );
  };

  return (
    <>
      <IndexHeader name="Salary Details" update={false} add={false} />
      <div className="flex flex-col ml-24 mt-12">
        <YouthSelectGroup onProgramChange={() => {}} onYouthChange={() => {}} />
      </div>
      <div className="m-24">
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="program details table">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>Week</StyledTableCell>
                <StyledTableCell>Remitted Date</StyledTableCell>
                <StyledTableCell>Hours Worked</StyledTableCell>
                <StyledTableCell>Hourly Rate</StyledTableCell>
                <StyledTableCell>Total</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {salaryDetails.map((item) => (
                <StyledTableRow key={item.week}>
                  <StyledTableCell>{item.week}</StyledTableCell>
                  <StyledTableCell>{item.remittedDate}</StyledTableCell>
                  <StyledTableCell>{item.hoursWorked}</StyledTableCell>
                  <StyledTableCell>
                    {item.hourlyRate.toFixed(2)}
                  </StyledTableCell>
                  <StyledTableCell>{item.total.toFixed(2)}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default SalaryDetails;
